import React, { useState } from "react";
import ReactDOM from "react-dom";

import img from "../assets/images/sidom/svg/fondoCard.svg";
import play from "../assets/images/sidom/svg/play.svg";
import playOra from "../assets/images/sidom/svg/playOran.svg";

export default function CardTestimoClientes({
  title,
  title2,
  description,
  buttonText,
  image,
  youtubeUrl,
}) {
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = (e) => {
    e.preventDefault();
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);

  function getEmbedUrl(url) {
    if (!url) return null;

    // Si ya es una URL de embed, la devuelve tal cual (aunque con un ligero ajuste)
    if (url.includes("/embed/")) {
      // Asegurarse de que sea no-cookie y sin parámetros adicionales aquí para que los agreguemos después
      const embedMatch = url.match(
        /(youtube(?:-nocookie)?\.com\/embed\/[\w-]+)/
      );
      if (embedMatch) {
        return `https://${embedMatch[1]}`; // Asegura https y el dominio correcto
      }
      return url; // Si no coincide el patrón, devuelve la URL original
    }

    // Convierte URLs de watch o youtu.be a formato embed (nocookie)
    const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
    if (match && match[1]) {
      return `https://www.youtube-nocookie.com/embed/${match[1]}`;
    }

    return url; // Si no es una URL de YouTube reconocida, devuelve la URL original
  }
  const embedUrl = getEmbedUrl(youtubeUrl);
  const apiUrl = process.env.REACT_APP_STRAPI_URL;
  return (
    <div className=" h-[400px] w-full sm:w-[350px]   rounded-lg shadow-lg relative overflow-hidden bg-sidom-blue dark:bg-sidom-gray text-sidom-light  dark:text-sidom-blue transition-colors duration-300 flex flex-col justify-center items-center p-4">
      <img
        src={img}
        alt="Fondo decorativo"
        className="absolute inset-0 z-0 opacity-90 -top-20 left-1/2  object-contain  pointer-events-none"
      />
      <div className="flex justify-center  items-center flex-col h-full relative z-10">
        <div className="z-10 flex flex-row items-center gap-4 mb-3">
          <div className="z-10  w-[50%]">
            <img
              src={image ? `${apiUrl}${image}` : null}
              alt={title}
              className="w-[100px] h-[100px] rounded-full object-cover border-2 border-sidom-dark shadow-md flex-shrink-0"
            />
          </div>

          <div className=" z-10 flex flex-col w-[50%] justify-start items-start">
            <h1 className="text-sm font-bold leading-[1.3]">{title}</h1>
            <h1 className="text-[11px] w-[150px] font-medium opacity-80 mb-4">
              {title2}
            </h1>

            <div className="relative ">
              {embedUrl ? (
                <>
                  <button
                    onClick={handleOpenModal}
                    className="relative inline-flex h-9 transition bg-sidom-orange  dark:bg-sidom-blue dark:text-sidom-light active:scale-95 overflow-hidden rounded-full p-[1px] focus:outline-none"
                  >
                    <div className="relative inline-flex   leading-snug h-full w-full items-center justify-start rounded-full px-2 text-nowrap text-sm font-bold gap-3">
                      <p className="">Ver Video</p>
                      <img
                        src={playOra}
                        alt="Logo "
                        className="hidden dark:block w-[13px]"
                      />
                      <img
                        src={play}
                        alt="Logo "
                        className="block dark:hidden w-[13px]"
                      />
                    </div>
                  </button>
                  {showModal &&
                    ReactDOM.createPortal(
                      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-70">
                        <div className="relative bg-sidom-blue rounded-lg shadow-lg p-4 flex flex-col items-center">
                          <button
                            onClick={handleCloseModal}
                            className="absolute top-2 right-2 text-white text-2xl font-bold hover:text-sidom-orange focus:outline-none"
                            aria-label="Cerrar"
                          >
                            ×
                          </button>
                          <iframe
                            width="560"
                            height="315"
                            // ¡CAMBIO CLAVE AQUÍ! Asegúrate de añadir los parámetros al final de la URL base
                            // Los parámetros van después del signo de interrogación.
                            // '&rel=0' asegura que las sugerencias son del mismo canal o relacionadas.
                            // '&modestbranding=1' reduce la visibilidad del logo de YouTube.
                            src={`${embedUrl}?controls=0&rel=0&modestbranding=1`}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                            className="rounded-lg "
                          ></iframe>
                        </div>
                      </div>,
                      document.body
                    )}
                </>
              ) : (
                <a
                  href="https://www.youtube.com/watch?v=J9oATQIj1Tg&feature=youtu.be"
                  className="relative inline-flex h-9 transition bg-sidom-orange  dark:bg-sidom-blue dark:text-sidom-light active:scale-95 overflow-hidden rounded-full p-[1px] focus:outline-none"
                >
                  <div className="relative inline-flex  leading-snug h-full w-full items-center justify-start rounded-full px-2 text-nowrap text-sm font-bold gap-3">
                    <p className="marca">Ver Video</p>
                    <img
                      src={playOra}
                      alt="Logo "
                      className="hidden dark:block w-[13px]"
                    />
                    <img
                      src={play}
                      alt="Logo "
                      className="block dark:hidden w-[13px]"
                    />
                  </div>
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="z-10 px-5 text-left">
          <p className="text-sm font-medium leading-3">
            <span className="text-lg font-bold">“</span>
            <span dangerouslySetInnerHTML={{ __html: description }} />
            <span className="text-lg font-bold">”</span>
          </p>
        </div>
      </div>
    </div>
  );
}
